import React, { useState, useEffect, useContext } from 'react'
import { Grid, Box, Alert, Typography } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'
import { useHistory, useLocation } from 'react-router-dom'
import Login from './auth/Login'
import LoadingDefault from './Elements/Loading/LoadingDefault'
import Api from '../Api'
import { KeDoContext, KeDoContextType } from '../kedo-context'
import logo from '../images/xlab.jpg'
import image1 from '../images/image1.jpg'
import image2 from '../images/image2.jpg'
import image3 from '../images/image3.jpg'
import image4 from '../images/image4.jpg'
import image5 from '../images/image5.jpg'

interface HomeProps {
    handleLogin: (data: any) => void
    handleLogout: () => void
}

const Home: React.FC<HomeProps> = ({ handleLogin, handleLogout }) => {
    const kedo = useContext<KeDoContextType>(KeDoContext)
    const history = useHistory()
    const location = useLocation()

    const [keyLogin, setKeyLogin] = useState(false)
    const [keyLoginFailure, setKeyLoginFailure] = useState(false)
    const [bgStyle, setBgStyle] = useState<SxProps<Theme>>({})

    useEffect(() => {
        const images = [image1, image2, image3, image4, image5]
        const idx = Math.floor(Math.random() * images.length)
        setBgStyle({
            backgroundImage: `url(${images[idx]})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: '100vh',
            width: '100%',
        })
    }, [])

    useEffect(() => {
        const query = new URLSearchParams(location.search)
        if (query.has('key') && query.has('username')) {
            const api = new Api()
            setKeyLogin(true)
            api.get('/key_login_check', {
                params: {
                    username: query.get('username'),
                    key: query.get('key'),
                },
            })
                .then((res) => {
                    localStorage.setItem('forceUpdate', '3')
                    handleSuccessfulAuth(res.data)
                })
                .catch(() => setKeyLoginFailure(true))
        }
    }, [location.search])

    const handleSuccessfulAuth = (data: any) => {
        handleLogin(data)
        const referer = localStorage.getItem('referer')
        if (
            referer &&
            referer !== '/' &&
            referer !== '' &&
            localStorage.getItem('forceUpdate') !== '3'
        ) {
            localStorage.removeItem('referer')
            history.push(referer)
        } else {
            history.push('/environment')
        }
    }

    if (keyLogin && !keyLoginFailure) {
        return (
            <Grid
                container
                justifyContent="center"
                alignItems="flex-start"
                className="login outerContainer"
                sx={bgStyle}
            >
                <Grid
                    size={{ xs: 10, sm: 8, md: 3 }}
                    className="mainContainer login"
                >
                    <Box textAlign="center">
                        <img
                            src={logo}
                            className="avatar inloggen"
                            alt="Xlab logo"
                        />
                        <Typography variant="h4">
                            {kedo.t('Login KeDo Next Gen')}
                        </Typography>
                        <Typography variant="body1">
                            {kedo.t('auto_login')}
                        </Typography>
                        <LoadingDefault size="6x" />
                    </Box>
                </Grid>
            </Grid>
        )
    }

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="flex-start"
            className="login outerContainer"
            sx={bgStyle}
        >
            <Grid
                size={{ xs: 10, sm: 8, md: 3 }}
                className="mainContainer login"
            >
                <Box textAlign="center">
                    {keyLoginFailure && (
                        <Alert severity="error">
                            {kedo.t('login_incorrect')}
                        </Alert>
                    )}
                    <Login
                        kedo={kedo}
                        title={kedo.t('KeDo Next Gen')}
                        handleSuccessfulAuth={handleSuccessfulAuth}
                    />
                    <Box mt={4} className="company-footer">
                        <img
                            src={logo}
                            className="avatar inloggen"
                            alt="Xlab logo"
                        />
                        <Typography variant="body2" className="company mt-2">
                            {kedo.t('Powered by KeDo')}
                        </Typography>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
}

export default Home
